module.exports = __webpack_public_path__ + "static/media/pampa-thumbnail.8e658026.webp";